import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCircleLarge = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12 3.875C7.51269 3.875 3.875 7.51269 3.875 12C3.875 16.4873 7.51269 20.125 12 20.125C16.4873 20.125 20.125 16.4873 20.125 12C20.125 7.51269 16.4873 3.875 12 3.875ZM1.625 12C1.625 6.27005 6.27005 1.625 12 1.625C17.7299 1.625 22.375 6.27005 22.375 12C22.375 17.7299 17.7299 22.375 12 22.375C6.27005 22.375 1.625 17.7299 1.625 12Z",
		fill: "currentColor"
	})]
});
export default SvgCircleLarge;
